import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { DraftFirmware, Firmware, FirmwareCompany, FirmwareId, PreSignedFirmware } from './firmwares.types';

export const getFirmwares = async (): Promise<AxiosResponse<Firmware[] & ApiError>> => {
  return instance.get<Firmware[]>('/firmwares').catch(e => e.response as AxiosError<ApiError> as never);
};

export const createFirmware = async (data: DraftFirmware): Promise<AxiosResponse<PreSignedFirmware & ApiError>> => {
  return instance.post('/firmwares', data).catch(e => e.response as AxiosError<ApiError> as never);
};

const firmwareApiPath = (id: number) => `/firmwares/${id}`;

export type GetFirmware = (params: { id: FirmwareId }) => Promise<AxiosResponse<Firmware>>;

export const getFirmware: GetFirmware = async ({ id }) => {
  return instance.get(`/firmwares/${id}`).catch(e => e.response as never);
};

export type UpdateFirmware = (params: { id: FirmwareId; data: Partial<Firmware> }) => Promise<AxiosResponse<Firmware>>;

export const updateFirmware: UpdateFirmware = async ({ id, data }) => {
  return instance.post(`/firmwares/${id}`, data).catch(e => e.response as never);
};

export const deleteFirmware = async ({ id }: { id: number }): Promise<AxiosResponse<Firmware & ApiError>> => {
  return instance.delete<Firmware>(firmwareApiPath(id)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const addFirmwareCompanyAPI = async ({
  id,
  data,
}: {
  id: number;
  data: { companyId: string };
}): Promise<AxiosResponse<FirmwareCompany>> => {
  return instance.post(`/firmwares/${id}/companies`, data).catch(e => e.response as never);
};

export const removeFirmwareCompanyAPI = async ({
  id,
  companyId,
}: {
  id: number;
  companyId: string;
}): Promise<AxiosResponse<void & ApiError>> => {
  return instance
    .delete(`/firmwares/${id}/companies/${companyId}`)
    .catch(e => e.response as AxiosError<ApiError> as never);
};
